<template>
    <div class="p-2">
        <div class="container-fluid pb-4">
            <div class="row header m-4">
                <div class="col">
                    <svg width="131px" height="59px" viewBox="0 0 131 59" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                        <!-- Generator: Sketch 59.1 (86144) - https://sketch.com -->
                        <title>TeleQ-Wide</title>
                        <desc>Created with Sketch.</desc>
                        <g id="Page-3" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                            <g id="TeleQ-Wide">
                                <polygon id="Fill-17" fill="#176CC6" points="11.1520999 27.3222548 0 27.3222548 0 23 27 23 27 27.3222548 15.8479001 27.3222548 15.8479001 57 11.1520999 57"></polygon>
                                <polygon id="Fill-19" fill="#176CC6" points="48 57 52 57 52 20 48 20"></polygon>
                                <path d="M100.500168,59 C104.159044,59 107.570577,57.9159133 110.444858,56.0551067 L112.346857,58.6682335 C112.585487,58.9966112 113.049005,59.0508324 113.355336,58.7865037 L117.035662,55.61117 C117.326911,55.3600577 117.361767,54.9174765 117.113083,54.6233261 L114.884308,52.0440876 L114.857496,52.0684872 C117.444885,48.8518097 119,44.7543754 119,40.2943363 C119,35.6736666 117.328587,31.4454234 114.57228,28.179608 L109.811082,32.2783978 C111.634655,34.4391158 112.739993,37.2372728 112.739993,40.2943363 C112.739993,44.8207965 110.322527,48.7857276 106.725654,50.9437345 C104.90007,52.0390043 102.772177,52.6700045 100.500168,52.6700045 C93.7511708,52.6700045 88.2600071,47.1180843 88.2600071,40.2943363 C88.2600071,37.1820348 89.4105909,34.3425342 91.2928159,32.1655498 L86.5745174,28 C83.72973,31.2905539 82,35.5906403 82,40.2943363 C82,50.6085792 90.2990842,59 100.500168,59" id="Fill-21" fill="#FFA800"></path>
                                <path d="M99.926763,28.5133139 C102.348444,28.5133139 104.605887,29.2515057 106.508038,30.5190198 C107.532686,31.2014201 108.451417,32.0407342 109.238421,33 L114,28.7821594 C112.826532,27.3518037 111.46,26.0971914 109.936268,25.0734166 C107.04835,23.1322196 103.613417,22 99.926763,22 C94.3771742,22 89.394041,24.5587396 86,28.5976986 L90.7186756,32.8838839 C92.964387,30.2118177 96.2548571,28.5133139 99.926763,28.5133139" id="Fill-22" fill="#FF4F00"></path>
                                <path d="M100.378848,16.7098078 C107.66249,16.7098078 114.19215,19.9324581 118.584062,25 L123,21.3012272 C117.542429,15.0044235 109.42934,11 100.378848,11 C91.4610149,11 83.4538481,14.888223 78,21.0262081 L82.3685608,24.7785864 C86.7577647,19.8388984 93.2018064,16.7098078 100.378848,16.7098078" id="Fill-23" fill="#FF4F00"></path>
                                <path d="M100.335756,5.78390736 C110.850727,5.78390736 120.276785,10.532324 126.617474,18 L131,14.2523329 C123.602305,5.54004422 112.604006,0 100.335756,0 C88.2472001,0 77.3929928,5.37982985 70,13.871866 L74.3355028,17.6735 C80.6721618,10.3950455 89.9749524,5.78390736 100.335756,5.78390736" id="Fill-24" fill="#FF4F00"></path>
                                <path d="M40.3615395,44.120793 C40.3289287,43.1567962 40.1759607,42.2732721 39.9026355,41.4698856 C39.6283016,40.6671696 39.2178095,39.9683977 38.6701504,39.373905 C38.1221551,38.7794124 37.4380015,38.3136762 36.616681,37.9760258 C35.7953605,37.6387108 34.8362007,37.4700532 33.741555,37.4700532 C32.6788476,37.4700532 31.7038867,37.6712352 30.8183532,38.0725932 C29.9321474,38.4746217 29.1831085,38.9963536 28.5715727,39.6387946 C27.9590283,40.2815709 27.4843232,40.9964374 27.1461126,41.7830588 C26.807902,42.5710214 26.6387967,43.3495955 26.6387967,44.120793 L40.3615395,44.120793 Z M26.6387967,47.5905109 C26.6387967,48.5866968 26.8559777,49.4936921 27.2910119,50.3131732 C27.7260462,51.1326543 28.2972388,51.831091 29.0066069,52.4094891 C29.7146303,52.9875519 30.5359508,53.4381994 31.4705685,53.7587493 C32.4045138,54.0803051 33.3710698,54.2409154 34.3699005,54.2409154 C35.7227428,54.2409154 36.8984111,53.9277422 37.8969056,53.3010604 C38.8954,52.6747139 39.8135442,51.8478562 40.6516744,50.8194811 L43.9372926,53.3252022 C41.5210706,56.4418458 38.1386286,58 33.7899668,58 C31.9856168,58 30.3510444,57.6938681 28.8855773,57.0839515 C27.4191016,56.4743703 26.1795565,55.6307473 25.1649248,54.5540886 C24.1502931,53.4777652 23.3689796,52.2089777 22.8213205,50.7470556 C22.2733252,49.2854688 22,47.7031728 22,45.9998323 C22,44.2974978 22.2978674,42.7155371 22.8939383,41.2529444 C23.489673,39.7916929 24.3109935,38.5229054 25.3585722,37.4459114 C26.4044699,36.3699233 27.6534284,35.5266357 29.1030944,34.9160485 C30.5524242,34.3061319 32.1305161,34 33.8383787,34 C35.8676421,34 37.5829009,34.3540802 38.9844913,35.0605641 C40.3857454,35.7677187 41.5372078,36.6914791 42.4392148,37.8315101 C43.3405493,38.972547 43.9931007,40.2577644 44.3961966,41.6868268 C44.7986201,43.1168951 45,44.5707699 45,46.048116 L45,47.5905109 L26.6387967,47.5905109 Z" id="Fill-18" fill="#176CC6"></path>
                                <path d="M74.3616073,44.120793 C74.328997,43.1567962 74.175695,42.2732721 73.9023738,41.4698856 C73.628044,40.6671696 73.217894,39.9683977 72.6702429,39.373905 C72.1219195,38.7794124 71.4381121,38.3136762 70.6168036,37.9760258 C69.7951589,37.6387108 68.8363493,37.4700532 67.7417195,37.4700532 C66.6786915,37.4700532 65.704081,37.6712352 64.8185605,38.0725932 C63.9323676,38.4746217 63.1833397,38.9963536 62.5718128,39.6387946 C61.9592773,40.2815709 61.4845792,40.9964374 61.1460374,41.7830588 C60.8078317,42.5710214 60.6387289,43.3495955 60.6387289,44.120793 L74.3616073,44.120793 Z M60.6387289,47.5905109 C60.6387289,48.5866968 60.8562429,49.4936921 61.2912708,50.3131732 C61.7262987,51.1326543 62.297483,51.831091 63.0065045,52.4094891 C63.7148537,52.9875519 64.535826,53.4381994 65.4707662,53.7587493 C66.4046979,54.0803051 67.3712398,54.2409154 68.3697196,54.2409154 C69.7228784,54.2409154 70.8981934,53.9277422 71.8970094,53.3010604 C72.895153,52.6747139 73.8132838,51.8478562 74.6514018,50.8194811 L77.9373082,53.3252022 C75.5211214,56.4418458 72.1387289,58 67.7901307,58 C65.9854708,58 64.3512585,57.6938681 62.8858128,57.0839515 C61.4193586,56.4743703 60.1798316,55.6307473 59.1652147,54.5540886 C58.1505978,53.4777652 57.3692958,52.2089777 56.8216447,50.7470556 C56.2736574,49.2854688 56,47.7031728 56,45.9998323 C56,44.2974978 56.297863,42.7155371 56.8939252,41.2529444 C57.4899874,39.7916929 58.3109597,38.5229054 59.3585231,37.4459114 C60.4047417,36.3699233 61.653682,35.5266357 63.1033268,34.9160485 C64.5526354,34.3061319 66.1307042,34 67.8382056,34 C69.8677756,34 71.5830093,34.3540802 72.984243,35.0605641 C74.3858128,35.7677187 75.5369223,36.6914791 76.4392522,37.8315101 C77.3405736,38.972547 77.9931154,40.2577644 78.3962055,41.6868268 C78.7986231,43.1168951 79,44.5707699 79,46.048116 L79,47.5905109 L60.6387289,47.5905109 Z" id="Fill-20" fill="#176CC6"></path>
                                <polygon id="Fill-25" fill="#FF4F00" points="98 47 103 47 103 34 98 34"></polygon>
                                <polygon id="Fill-26" fill="#FF4F00" points="94 43 107 43 107 38 94 38"></polygon>
                            </g>
                        </g>
                    </svg>
                </div>
                <div class="col">
                    <b-alert v-if="generalErrorMessage" :show="true" fade variant="danger">
                        {{ generalErrorMessage }}
                    </b-alert>
                </div>
            </div>
            <div class="row patient-summary py-2">
                <div class="col-6">
                    <h5><a @click.prevent.stop="editPatient(visitDetails.organizationPatientId)" href="#">{{ visitDetails.firstName +' ' + visitDetails.lastName }}&nbsp;&nbsp;<font-awesome-icon size="sm" :icon="['far', 'edit']"/></a></h5>
                    <div class="mb-4">
                    <span class="field-label">Birth Date: </span>{{ formatBirthDate(visitDetails.dob) }}<br>
                    <span class="field-label">MRN: </span>{{ visitDetails.mrn }}<br>
                    <span class="field-label">Patient ID: </span>{{ visitDetails.patientIdFromOrg }}<br>
                    <span class="field-label">Phone: </span>{{ visitDetails.phoneNumber }}<br>
                    <span class="field-label">E-Mail: </span>{{ visitDetails.email }}<br>
                    </div>
                    <template v-if="visitDetails.orthoReasonForVisit">
                        <h4><font-awesome-icon class="mr-2" :icon="[ 'fal', 'hand-holding-medical' ]"/>Reason for Visit</h4>
                    <div class="mb-4">
                        <span class="field-label">Primary Body Part: </span><template v-if="visitDetails.orthoReasonForVisit.primaryBodyPart">{{ visitDetails.orthoReasonForVisit.primaryBodyPart.name }}</template><br>
                        <span class="field-label">Cause of Pain: </span><template v-if="visitDetails.orthoReasonForVisit.painCause">{{ visitDetails.orthoReasonForVisit.painCause.name }}</template><br>
                        <span class="field-label">Symptoms: </span><span v-for="painType in selectedPainTypes" :key="painType.painTypeId">{{ painType.name }}&nbsp;</span><br>
                        <span class="field-label">How did it occur? </span>{{ visitDetails.orthoReasonForVisit.details }}<br>
                        <template v-if="visitDetails.orthoReasonForVisit.lawyerOption"><span class="field-label">Lawyer: </span>{{ visitDetails.orthoReasonForVisit.lawyerOption.name }}<br></template>
                        <span class="field-label">Onset: </span><template v-if="visitDetails.orthoReasonForVisit.injuryOnset">{{ visitDetails.orthoReasonForVisit.injuryOnset.name }}</template><br>
                        <span class="field-label">Pain Severity: </span>{{ visitDetails.orthoReasonForVisit.painSeverity }}<br>
                        <span class="field-label">Functional Limitation: </span>{{ visitDetails.orthoReasonForVisit.functionalLimitation }}<br>
                        <span class="field-label">Better: </span><span v-for="option in selectedBetterOptions" :key="'better-' + option.orthoBetterOptionId">{{ option.name }}&nbsp;</span><br>
                        <span class="field-label">Worse: </span><span v-for="option in selectedWorseOptions" :key="'worse-' + option.orthoWorseOptionId">{{ option.name }}&nbsp;</span><br>
                        <span class="field-label">Prior Treatments: </span>
                        <span v-for="option in visitDetails.orthoReasonForVisit.priorTreatmentOptions" :key="'prior-' + option.orthoPriorTreatmentId"><font-awesome-icon v-if="!option.isSelected" :icon="['far', 'circle']"/><font-awesome-icon v-if="option.isSelected" :icon="[ 'far', 'check-circle']"/>&nbsp;{{ option.name }}&nbsp;</span><br>
                        <span class="field-label">Photos: </span><br>
                        <img v-if="visitDetails.orthoReasonForVisitPhotos[0]" class="patient-photo-sizing" :src="visitDetails.orthoReasonForVisitPhotos[0]">
                        <img v-if="visitDetails.orthoReasonForVisitPhotos[1]" class="patient-photo-sizing patient-photo-right" :src="visitDetails.orthoReasonForVisitPhotos[1]">
                        <br>
                    </div>
                    </template>
                    <template v-if="visitDetails.pharmacy && visitDetails.pharmacy.name">
                        <h4><font-awesome-icon class="mr-2" :icon="[ 'fal', 'mortar-pestle' ]"/>Pharmacy</h4>
                        <div class="mb-4">
                            <div>{{ visitDetails.pharmacy.name }}</div>
                            <div>{{ visitDetails.pharmacy.street1}}</div>
                            <div v-show="visitDetails.pharmacy.street2">{{ visitDetails.pharmacy.street2}}</div>
                            <div>{{ visitDetails.pharmacy.city }}, {{ visitDetails.pharmacy.state.short }} {{ visitDetails.pharmacy.zip }}</div>
                        </div>
                    </template>
                    <template v-if="visitDetails.medications">
                        <h4><font-awesome-icon class="mr-2" :icon="[ 'fal', 'prescription-bottle' ]"/>Medications</h4>
                        <div class="mb-4">
                            <div v-for="medication in visitDetails.medications" :key="'medication-' + medication.organizationPatientMedicationId">
                                {{ medication.name }}, {{ medication.dosage }} - {{ medication.frequency }}
                            </div>
                        </div>
                    </template>
                    <template v-if="visitDetails.allergies">
                        <h4><font-awesome-icon class="mr-2" :icon="[ 'fal', 'allergies' ]"/>Allergies</h4>
                        <div class="mb-4">
                            <div v-for="allergy in visitDetails.allergies" :key="'allergy-' + allergy.organizationPatientAllergyId">
                                {{ allergy.name }}
                            </div>
                        </div>
                    </template>
                    <template v-if="visitDetails.medicalConditions">
                        <h4><font-awesome-icon class="mr-2" :icon="[ 'fal', 'books-medical' ]"/>Medical History</h4>
                        <div class="mb-4">
                            <div v-for="medicalCondition in visitDetails.medicalConditions" :key="'medicalCondition-' + medicalCondition.organizationPatientMedicalConditionId">
                                {{ medicalCondition.name }}
                            </div>
                        </div>
                    </template>
                    <template v-if="visitDetails.surgeries">
                        <h4><font-awesome-icon class="mr-2" :icon="[ 'fal', 'scalpel-path' ]"/>Procedures</h4>
                        <div class="mb-4">
                            <div v-for="surgery in visitDetails.surgeries" :key="'surgery-' + surgery.organizationPatientSurgeryId">
                                {{ surgery.name }}<span v-if="surgery.sideName">, {{ surgery.sideName }}</span><span v-if="surgery.month">, {{ surgery.month + '/' + surgery.year }}</span>
                            </div>
                        </div>
                    </template>
                    <div id="picture-container"></div>
                </div>
                <div class="col-6 video-container">
                    <div v-if="elapsedMillis > 0" class="text-center my-2">
                        Duration: {{ sessionDuration }}
                    </div>
                    <div ref="mainVideoContainer" id="main-video-container">
                        <div id="control-container">
                            <div v-show="!isConnected">
                                <button type="button" @click.prevent="connectToRoom()" class="control-button connect"><span v-if="isConnecting" ><font-awesome-icon size="2x" icon="spinner" pulse/></span><span v-if="!isConnecting"><font-awesome-icon class="" size="2x" :icon="['fal', 'video']"/></span></button>
                                <div class="control-label text-center">Connect</div>
                            </div>
                            <div v-show="isConnected">
                                <button type="button" @click.prevent="disconnectFromRoom()" class="control-button disconnect"><font-awesome-icon class="" size="2x" :icon="['fal', 'video-slash']"/></button>
                                <div class="control-label text-center">Disconnect</div>
                            </div>
                            <div v-show="isConnected">
                                <button type="button" v-if="isMuted" @click.prevent="toggleMute()" class="control-button mute-stop"><font-awesome-icon size="2x" :icon="['fal', 'microphone-alt-slash']"/></button>
                                <button type="button" v-if="!isMuted" @click.prevent="toggleMute()" class="control-button mute"><font-awesome-icon size="2x" :icon="['fal', 'microphone-alt']"/></button>
                                <div v-if="isMuted" class="control-label text-center">Unmute</div>
                                <div v-if="!isMuted" class="control-label text-center">Mute</div>
                            </div>
                            <div v-show="isConnected">
                                <button type="button" @click.prevent="takeSnapshot()" class="control-button camera"><font-awesome-icon class="" size="2x" :icon="['fal', 'portrait']"/></button>
                                <div class="control-label text-center">Picture</div>
                            </div>
                            <div v-if="screenShareSupported()" v-show="isConnected">
                                <button v-if="screenShareActive" type="button" @click.prevent="stopScreenShare()" class="control-button screen-share-stop">
                                    <font-awesome-layers class="fa-2x">
                                        <font-awesome-icon :icon="['fal', 'laptop-medical']"/>
                                        <font-awesome-icon :icon="['fal', 'slash']"/>
                                    </font-awesome-layers>
                                </button>
                                <button v-if="!screenShareActive" type="button" @click.prevent="startScreenShare()" class="control-button screen-share"><font-awesome-icon class="" size="2x" :icon="['fal', 'laptop-medical']"/></button>
                                <div v-if="!screenShareActive" class="control-label text-center">Share</div>
                                <div v-if="screenShareActive" class="control-label text-center">Stop</div>
                            </div>
                            <div v-if="pipSupported()" v-show="isConnected">
                                <button v-if="pipActive" type="button" @click.prevent="stopPip()" class="control-button pip-stop">
                                    <font-awesome-layers class="fa-2x">
                                        <font-awesome-icon :icon="['fal', 'external-link']"/>
                                        <font-awesome-icon :icon="['fal', 'slash']"/>
                                    </font-awesome-layers>
                                </button>
                                <div v-if="pipActive" class="control-label text-center">Close</div>
                                <button v-if="!pipActive" type="button" @click.prevent="startPip()" class="control-button pip"><font-awesome-icon class="" size="2x" :icon="['fal', 'external-link']"/></button>
                                <div v-if="!pipActive" class="control-label text-center">Q Pop</div>
                            </div>
                        </div>
                    </div>
                    <participant-tray :show-local="showLocalInTray" @video-clicked="videoClicked" :main-display-track="mainVideoTrack"></participant-tray>
                </div>
            </div>
        </div>
        <edit-patient-modal :id="editingPatientId" @patientUpdated="patientUpdated" :visible="showingPatientDetails" @update:visible="visible => showingPatientDetails = visible"></edit-patient-modal>
    </div>
</template>

<script>
  import api from '../services/api'
  import ErrorsMixin from '../mixins/ErrorsMixin'
  import TwilioVideo from 'twilio-video'
  import moment from 'moment-timezone'
  import EditPatientModal from '../components/EditPatientModal'
  import VirtualVisitEvents from '../services/virtual-visit-events'
  import ParticipantTray from '../components/ParticipantTray'
  import AnalyticsMixin from '@/mixins/AnalyticsMixin'

  export default {
    name: 'VirtualVisit',

    components: { EditPatientModal, ParticipantTray },

    mixins: [ErrorsMixin, AnalyticsMixin],

    props: {
      id: {
        default: 0
      }
    },

    data () {
      return {
        visitDetails: {
          orthoReasonForVisit: {
            primaryBodyPart: {},
            painCause: {},
            injuryOnset: {},
            lawyerOption: {}
          },
          pharmacy: {}
        },
        virtualVisit: {
          token: null,
          roomSid: null,
          identity: null
        },
        patient: {

        },
        isSaving: false,
        localTracks: null,
        isConnected: false,
        isConnecting: false,
        isMuted: false,
        room: null,
        showingPatientDetails: false,
        editingPatientId: 0,
        allParticipants: [],
        mainVideoTrack: null,
        elapsedMillis: 0,
        sessionTimer: null,
        screenShareTrack: null,
        screenShareActive: false,
        showLocalInTray: false,
        pipActive: false,
        isShuttingDown: false,
        orthoReasonForVisitPhotos: []
      }
    },

    computed: {
      logoUrl () {
        return this.$store.orgLogoUrl
      },

      orgName () {
        return this.$store.orgName
      },

      selectedPainTypes () {
        if (this.visitDetails.orthoReasonForVisit && this.visitDetails.orthoReasonForVisit.painTypeOptions) {
          return this.visitDetails.orthoReasonForVisit.painTypeOptions.filter((painType) => {
            return painType.isSelected
          })
        }

        return []
      },

      selectedBetterOptions () {
        if (this.visitDetails.orthoReasonForVisit && this.visitDetails.orthoReasonForVisit.betterOptions) {
          return this.visitDetails.orthoReasonForVisit.betterOptions.filter((option) => {
            return option.isSelected
          })
        }

        return []
      },

      selectedWorseOptions () {
        if (this.visitDetails.orthoReasonForVisit && this.visitDetails.orthoReasonForVisit.worseOptions) {
          return this.visitDetails.orthoReasonForVisit.worseOptions.filter((option) => {
            return option.isSelected
          })
        }

        return []
      },

      sessionDuration () {
        if (this.elapsedMillis > 0) {
          const hours = Math.floor((this.elapsedMillis / 1000) / 60 / 60)
          let remainder = this.elapsedMillis - (hours * 60 * 60 * 1000)
          let minutes = Math.floor(remainder / 1000 / 60)
          remainder = remainder - (minutes * 60 * 1000)
          const seconds = Math.floor(remainder / 1000)

          if (!minutes) {
            minutes = 0
          }

          if (hours) {
            return hours + ':' + ('00' + minutes).slice(-2) + ':' + ('00' + seconds).slice(-2)
          } else {
            return ('00' + minutes).slice(-2) + ':' + ('00' + seconds).slice(-2)
          }
        } else {
          return ''
        }
      },

      localVideoTrack () {
        let videoTrack = null
        if (this.localTracks) {
          this.localTracks.forEach((track) => {
            if (track.kind === 'video') {
              videoTrack = track
            }
          })
        }

        return videoTrack
      }
    },

    watch: {
      mainVideoParticpant (newValue, oldValue) {
        if (newValue !== null) {
          if (oldValue !== null) {
            this.showParticipantInTray(oldValue)
          } else {
            // Put the local into a partcipant
            const localParticipant = this.allParticipants.filter((particpant) => {
              return particpant.identity === this.virtualVisit.identity
            }).shift()
            if (localParticipant) {
              this.showParticipantInTray(localParticipant)
            }
          }
          this.showParticipantInMainVideo(newValue)
        }
      }
    },

    methods: {
      screenShareSupported () {
        if (typeof navigator === 'undefined' ||
          !navigator.mediaDevices ||
          !navigator.mediaDevices.getDisplayMedia) {
          return false
        }

        return true
      },

      pipSupported () {
        return !!document.pictureInPictureEnabled
      },

      startSessionTimer () {
        this.sessionTimer = setInterval(() => {
          this.elapsedMillis += 100
        }, 100)
      },

      stopSessionTimer () {
        clearInterval(this.sessionTimer)
      },

      initializeVideo: function () {
        TwilioVideo.createLocalTracks().then(tracks => {
          this.localTracks = tracks
          this.showPreviewVideo()
        }).catch(error => {
          this.trackEvent(this.$options.name, 'InitializeVideoError', error.message)
          // console.error(`Unable to initialize local video: ${error.message}`)
        })
      },

      showPreviewVideo: function () {
        if (this.isShuttingDown) {
          return
        }

        const mainContainer = document.querySelector('#main-video-container')
        this.clearMainVideo()

        if (this.localTracks) {
          this.localTracks.forEach((track) => {
            mainContainer.prepend(track.attach())
          })
        }
      },

      clearMainVideo () {
        const mainContainer = document.querySelector('#main-video-container')
        const videos = document.querySelectorAll('#main-video-container > video')
        if (videos) {
          for (const el of videos) {
            mainContainer.removeChild(el)
          }
        }

        const audios = document.querySelectorAll('#main-video-container > audio')
        if (audios) {
          for (const el of audios) {
            mainContainer.removeChild(el)
          }
        }
      },

      loadData () {
        api.get('/Dashboard/VirtualVisit/' + this.id + '/Details').then(response => {
          this.trackEvent(this.$options.name, 'Load', 'ResponseTime', response.config.requestDuration)
          this.visitDetails = response.data
        }).catch(error => {
          if (!this.$store.canHandleNetworkError(error)) {
            this.$store.logErrorResponse(this.$options.name, 'LoadError', error)
            this.setFromApiErrorResponse(error)
          }
        })
      },

      editPatient (patientId) {
        this.editingPatientId = patientId
        this.showingPatientDetails = true
      },

      patientUpdated (updatedPatient) {
        this.showingPatientDetails = false
        this.loadData()
      },

      formatBirthDate (dob) {
        return moment(dob).utc().format('MM/DD/YYYY')
      },

      connectToRoom: function () {
        this.clearAllErrors()
        this.isConnecting = true
        const connectionOptions = {
          logLevel: 'info',
          tracks: this.localTracks
        }

        api.get('/Dashboard/VirtualVisit/' + this.id + '/Start').then(response => {
          this.trackEvent(this.$options.name, 'VirtualVisitStart', 'ResponseTime', response.config.requestDuration)
          this.virtualVisit = response.data
          TwilioVideo.connect(this.virtualVisit.token, connectionOptions).then(room => {
            this.trackEvent(this.$options.name, 'RoomConnectSuccess', room.name)
            this.startSessionTimer()
            this.room = room
            VirtualVisitEvents.connectedToRoom(this.room)
            this.isConnecting = false
            this.isConnected = true
            this.setupInitialVideoView()
            this.room.localParticipant.on('trackStopped', (track) => {
              this.setupInitialVideoView()
            })
            this.room.on('trackSubscribed', this.trackSubscribed)
            this.room.on('trackUnpublished', this.trackUnpublished)
            this.room.on('participantDisconnected', this.participantDisconnected)
          }).catch(error => {
            this.trackEvent(this.$options.name, 'RoomConnectError', error.message)
            this.$log.error(`Unable to connect to Room: ${error.message}`)
            this.isConnecting = false
            this.isConnected = false
          })
        }).catch(error => {
          this.isConnecting = false
          this.isConnected = false
          if (!this.$store.canHandleNetworkError(error)) {
            this.$store.logErrorResponse(this.$options.name, 'VirtualVisitStartError', error)
            this.setFromApiErrorResponse(error)
          }
        })

      },

      showTrack (track) {
        this.mainVideoTrack = track

        const media = this.$refs.mainVideoContainer.querySelectorAll('video,audio')
        if (media) {
          for (const el of media) {
            this.$refs.mainVideoContainer.removeChild(el)
          }
        }

        if (track) {
          if (this.localVideoTrack) {
            if (this.localVideoTrack.sid !== track.sid) {
              this.showLocalInTray = true
            } else {
              this.showLocalInTray = false
            }
          }
          this.$refs.mainVideoContainer.prepend(track.attach())
        } else {
          this.showLocalInTray = false
          this.showPreviewVideo()
        }
      },

      videoClicked: function (track) {
        this.showTrack(track)
      },

      setupInitialVideoView () {
        if (!this.room || this.isShuttingDown) {
          return
        }

        let patientVideo = null
        this.room.participants.forEach((participant) => {
          if (participant.identity.startsWith('Patient-')) {
            participant.videoTracks.forEach((publication) => {
              if (publication.isSubscribed) {
                patientVideo = publication.track
              }
            })
          }
        })

        if (patientVideo) {
          this.showTrack(patientVideo)
        } else {
          this.showTrack(null)
        }
      },

      trackSubscribed (track, publication, participant) {
        if (track.kind === 'video') {
          if (!this.mainVideoTrack) {
            this.setupInitialVideoView()
          }
        }
      },

      trackUnpublished (publication) {
        this.$log.debug('Unpublish notification for:')
        this.$log.debug(publication)
        if (publication.track && publication.track.kind === 'video') {
          if (this.mainVideoTrack) {
            if (this.mainVideoTrack.sid === publication.track.sid) {
              this.setupInitialVideoView()
            }
          }
        } else if (publication.kind === 'video' && publication.trackSid && this.mainVideoTrack) {
          if (this.mainVideoTrack.sid === publication.trackSid) {
            this.setupInitialVideoView()
          }
        }
      },

      participantDisconnected (participant) {
        this.$log.debug('Participant Disconnected notification for:')
        this.$log.debug(participant)
        if (this.mainVideoTrack) {
          participant.videoTracks.forEach((publications) => {
            if (this.mainVideoTrack.sid === publications.trackSid) {
              this.setupInitialVideoView()
            }
          })
        }
      },

      disconnectFromRoom () {
        this.stopSessionTimer()
        this.stopScreenShare()
        if (this.pipActive) {
          this.stopPip()
        }
        this.allParticipants = []
        this.mainVideoParticpant = null
        this.showPreviewVideo()
        if (this.room && this.room.state !== 'disconnected') {
          try {
            this.room.disconnect()
          } catch (error) {
            // Sometimes we get an error on disconnecting
          }

          this.isConnected = false
          this.room = null
          this.trackEvent(this.$options.name, 'DisconnectedRoom')
          const participantsContainer = document.querySelector('#participants-container')
          const participantContainers = document.querySelectorAll('#participants-container > div')
          if (participantContainers) {
            for (const el of participantContainers) {
              participantsContainer.removeChild(el)
            }
          }
        }
      },

      toggleMute () {
        const publications = this.room.localParticipant.audioTracks

        publications.forEach((publication) => {
          this.trackEvent(this.$options.name, 'MuteAudio', this.isMuted ? 'Unmuting' : 'Muting')
          if (this.isMuted) {
            this.isMuted = false
            publication.track.enable()
          } else {
            this.isMuted = true
            publication.track.disable()
          }
        })
      },

      startScreenShare () {
        if (!this.screenShareSupported()) {
          return
        }
        navigator.mediaDevices.getDisplayMedia({
          video: {
            height: 720,
            width: 1280
          }
        }).then((stream) => {
          this.screenShareTrack = new TwilioVideo.LocalVideoTrack(stream.getVideoTracks()[0], { name: 'ScreenShare' })
          this.screenShareTrack.on('stopped', (track) => {
            this.stopScreenShare()
          })
          this.room.localParticipant.publishTrack(this.screenShareTrack, { name: 'ScreenShare' })
          this.screenShareActive = true
        })
      },

      stopScreenShare () {
        if (this.screenShareTrack) {
          this.screenShareTrack.stop() // Must be called before unpublish to get an event
          if (this.room && this.room.localParticipant && this.screenShareTrack) {
            this.room.localParticipant.unpublishTrack(this.screenShareTrack)
          }
        }

        this.screenShareTrack = null
        this.screenShareActive = false
        this.setupInitialVideoView()
      },

      startPip () {
        if (!this.pipSupported()) {
          return
        }

        const videoElement = document.querySelector('#main-video-container > video')
        if (videoElement) {
          videoElement.requestPictureInPicture().then(() => {
            this.pipActive = true
            videoElement.addEventListener('leavepictureinpicture', () => {
              this.pipActive = false
            })
          }).catch((error) => {
            this.pipActive = false
            this.$log.error('Error initializing pip:')
            this.$log.error(error)
          })
        }

      },

      stopPip () {
        if (!this.pipSupported()) {
          return
        }

        if (document.pictureInPictureElement) {
          document.exitPictureInPicture().then(() => {
            this.pipActive = false
          }).catch((error) => {
            this.$log.error('Error stopping pip:')
            this.$log.error(error)
          })
        }
      },

      detachTrack: function (track) {
        if (track) {
          track.detach().forEach((element) => {
            element.remove()
          })
        }
      },

      stopRecording: function () {
        if (this.pipActive) {
          this.stopPip()
        }
        this.stopScreenShare()
        for (const track of this.localTracks) {
          if (this.room && this.room.localParticipant) {
            this.room.localParticipant.unpublishTrack(track)
          }
          this.detachTrack(track)
          track.disable()
          track.stop()
        }
        this.localTracks = null
        this.trackEvent(this.$options.name, 'StoppedRecording')
      },

      takeSnapshot: function () {
        const video = document.querySelector('#main-video-container > video')

        if (video) {
          const pictureCanvas = document.createElement('canvas')
          pictureCanvas.style.height = video.clientHeight / 2 + 'px'
          pictureCanvas.style.width = video.clientWidth / 2 + 'px'
          const pictureContainer = document.getElementById('picture-container')
          pictureContainer.appendChild(pictureCanvas)
          const context = pictureCanvas.getContext('2d')
          context.clearRect(0, 0, pictureCanvas.width, pictureCanvas.height)
          context.drawImage(video, 0, 0, pictureCanvas.width, pictureCanvas.height)
        }

      }

    },

    created () {
      this.loadData()
    },

    mounted () {
      this.initializeVideo()
    },

    beforeDestroy () {
      this.isShuttingDown = true
      this.disconnectFromRoom()
      this.stopRecording()
    }
  }
</script>

<style>
    #main-video-container{
        min-height: 500px;
        position: relative;
        padding-bottom: 80px;
        overflow: hidden;
    }
    #main-video-container video {
        object-fit: scale-down;
        object-position: top;
        width: auto;
        height: 100%;
        min-height: 500px;
        display: block;
        margin: 0 auto;
    }

    #control-container {
        height: 100px;
        position: absolute;
        bottom: 0;
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        padding-top: 20px;
    }

    #picture-container {
        display: flex;
        justify-content: flex-start;
        align-items: flex-start;
        flex-wrap: wrap;
    }

    #picture-container > canvas {
        margin: 10px;
    }
    .control-button {
        border: 1px solid rgb(255, 70, 0);
        border-radius: 50%;
        width: 60px;
        height: 60px;
        margin-right: 20px;
        margin-left: 20px;
        padding: 0;
    }

    .control-button:focus {
        outline: none;
    }

    .control-label {
        color: black;
    }

    .connect {
        border: 1px solid rgb(255, 70, 0);
        color: rgb(255, 70, 0);
    }

    .disconnect, .screen-share-stop, .pip-stop, .mute-stop {
        border: 1px solid rgb(255, 70, 0);
        background-color: rgb(255, 70, 0);
        color: white;
    }

    .screen-share-stop .fa-layers {
        margin-left: -7px;
    }

    .pip-stop div.fa-layers svg.fa-slash {
        margin-left: -3px;
    }

    .mute, .camera, .screen-share, .pip {
        background-color: white;
        color: rgb(255, 70, 0);
    }

    .disconnect:disabled {
        border-color: lightcoral;
        background-color: lightcoral;
        color: white;
    }

    .patient-summary-header h5 {
        color: #001859;
    }

    .patient-summary .column {
        padding: 0.75rem;
        vertical-align: bottom;
        border-collapse: collapse;
    }

    .patient-summary {
        border-top: 1px solid #FFA800;
        border-bottom: 1px solid #dee2e6;
        background-color: #f9f9f9;
        font-size: 1.2em;
    }

    .patient-photo-sizing {
        margin-top: 10px;
        width: 49.5%
    }

    .patient-photo-right {
        margin-left: 1%
    }
</style>
